/**
 * checks if name is consistent only of illegal characters ( whitespace )
 * @param name
 */
export const isValidName = (name: string): boolean => {
    return !!(name.replace(/\s/g, '') ?? null)
}